<template>
  <div class="NavBarLeft">
    <div class="nav_container header">
      <!-- logo -->
      <div class="header_logo">
        <img class="logo_title" src="@/assets/image/50_logo.png" alt="">
        <img class="logo" src="@/assets/image/logo_es.png" alt="">
      </div>
      <div class="nav_list">
        <!-- <router-link style="width: 100%; height: 100%;" v-for="(item, index) in navList" :key="'nav' + index"
          :to="item.path" @click.native="handleNavClick($event, item, index)"> -->
        <div class="nav_item" :class="isActive(item.path)" v-for="(item, index) in navList" :key="'nav' + index"
          @click="handleNavClick($event, item, index)">
          <img class="icon" :src="isActive(item.path) ? item.src : item.noSrc" alt="">
          <div class="title">{{ item.title }}</div>
        </div>
        <!-- </router-link> -->
      </div>
      <div class="qrCorde_box">
        <div class="code_top">
          <div class="code_top_lt" ref="qrContainer">
            <!-- <img src="@/assets/image/qr_code.png" alt=""> -->
          </div>
          <div class="code_top_rt">
            <div>
              <img class="code_top_logo" src="@/assets/image/50_logo.png" alt="">
              <h1>爆款手游，独家福利！</h1>
            </div>
            <div>
              <img class="code_top_scan" src="@/assets/image/scan.png" alt="">
              <h6>用微信/浏览器扫码下载APP</h6>
            </div>
          </div>
        </div>
        <div class="code_btn">
          <a :href="box_link" target="_self" rel="noopener noreferrer">下载APP安装包</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '@/util/Bus'
import { postData } from '@/api/api.js'
import QRCode from 'qrcodejs2'
export default {
  name: 'NavBarLeft',
  data() {
    return {
      navIndex: 0,
      box_link: '',
      navList: [{ title: '首页', path: '/index', src: require('@/assets/image/home_face_home_ic.png'), noSrc: require('@/assets/image/no_home_face_home_ic.png') }, { title: '新游', path: '/newGame', src: require('@/assets/image/new_game_ic.png'), noSrc: require('@/assets/image/no_new_game_ic.png') }, { title: '排行', path: '/rankingGame', src: require('@/assets/image/rank_level_ic.png'), noSrc: require('@/assets/image/no_rank_level_ic.png') }, { title: '预约', path: '/reserveGame', src: require('@/assets/image/reserve_time_ic.png'), noSrc: require('@/assets/image/no_reserve_time_ic.png') }, { title: '我的', path: '/my', src: require('@/assets/image/my_face_ic.png'), noSrc: require('@/assets/image/no_my_face_ic.png') }],
    }
  },
  created() {
    this.boxLink()
  },
  methods: {
    handleNavClick(event, item, index) {
      // 从 sessionStorage 获取登录状态（存储值为字符串 "true" 或 "false"）
      const isLogin = localStorage.getItem('loginMes') === 'true';
      if (!isLogin) {
        if (item.path === '/my') {
          event.preventDefault();
          // 打开登录弹窗
          Bus.$emit("loginShow", true);
        } else {
          this.handelNav(index, item);
        }
      } else {
        this.handelNav(index, item);
      }
    },
    handelNav(index, item) {
      if (this.$route.path === item.path) return
      this.$router.push(item.path);
      this.navIndex = index
    },
    isActive(path) {
      return this.$route.path === path ? 'nav_item_active' : ''; // 比较当前路径
    },
    // boxLink
    async boxLink() {
      try {
        const res = await postData('/box/box-link')
        if (res?.code === 0) {
          this.box_link = res.data.box_link
          this.generateQRCode(res.data.landing_url)
        }
      } catch (err) {
        console.log(err)
      }
    },
    generateQRCode(box_link) {
      // 清空容器，防止重复生成
      this.$refs.qrContainer.innerHTML = ''
      // 3. 生成二维码
      new QRCode(this.$refs.qrContainer, {
        text: box_link, // 二维码内容
        width: 100,                  // 二维码宽度
        height: 100,                 // 二维码高度
        colorDark: '#000000',        // 二维码颜色
        colorLight: '#ffffff',       // 二维码背景色
        correctLevel: QRCode.CorrectLevel.H // 纠错级别
      })
    }
  },

}
</script>
<style lang="less" scoped>
.navBarLeft {
  position: relative;
}

// 侧边栏
.header {
  position: sticky;
  top: 80px;
  z-index: 99;
  // height: 100vh;
}

.nav_container {
  // width: 345px;

  .header_logo {
    height: 80px;
    padding-left: 14px;
    box-sizing: border-box;
    overflow: hidden;
    display: block;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: normal;
    position: fixed;
    top: 0;
    cursor: pointer;

    .logo_title {
      width: 110px;
    }

    .logo {
      display: none;
    }

    .header_logo>img {
      box-sizing: border-box;
      height: 36px;
    }
  }

  .nav_list {
    margin-top: 80px;
    background-color: #ffffff;
    width: 100%;
    display: flex;
    flex-direction: column;
    // align-items: center;
    justify-content: normal;

    .nav_item {
      width: 100%;
      max-width: 345px;
      overflow: hidden;
      box-sizing: border-box;
      height: 48px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: normal;
      cursor: pointer;
      border-radius: 24px;
      text-decoration: none;
      font-size: 16px;
      color: #666666;
      font-weight: 700;
      padding: 0 16px;

      .icon {
        min-width: 28px;
      }

      .title {
        flex: 1;
        text-align: left;
        padding-left: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  .nav_list>:not(:first-child) {
    margin-top: 8px;
  }

  .nav_list .nav_item_active.nav_item {
    color: #FF3838;
    background-color: #d9d9d9;
  }

  .qrCorde_box {
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    padding: 20px 16px;
    box-sizing: border-box;
    background-color: #F5F5F5;
    border-radius: 20px;

    .code_top {
      display: flex;

      .code_top_lt {
        width: 100px;
        height: 100px;
        border: 2px solid #ffffff;
        // img {
        //   width: 100px;
        //   height: 100px;
        // }
      }

      .code_top_rt {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 15px;

        h1 {
          font-size: 16px;
        }

        h6 {
          font-size: 12px;
          text-align: left;
        }

        .code_top_logo {
          height: 28px;
        }

        .code_top_scan {
          width: 18px;
          height: 18px;
        }
      }
    }

    .code_btn {
      height: 42px;
      margin-top: 20px;
      line-height: 42px;
      text-align: center;
      border-radius: 21px;
      font-size: 12px;
      color: #ffffff;
      background-color: #FF3838;
      cursor: pointer;

      a {
        color: #ffffff;
      }
    }
  }
}

// @media (min-width: 1544px) {
//   .header {
//     flex: 0 0 345px;
//   }
// }

// @media (min-width: 1336px) and (max-width: 1544px) {
//   .header {
//     flex: 0 0 280px;
//   }

// }

// @media (min-width: 1280px) and (max-width: 1336px) {
//   .header {
//     flex: 0 0 240px;
//   }

// }

// @media (min-width: 1144px) and (max-width: 1280px) {
//   .header {
//     flex: 0 0 56px;
//   }
// }

// @media (min-width: 752px) and (max-width: 1144px) {
//   .header {
//     flex: 0 0 56px;
//   }
// }
@media (max-width: 1280px) {

  //屏蔽扫码功能
  .header .qrCorde_box {
    display: none;
  }

  // 屏蔽左侧导航文字

  .nav_container .nav_list .nav_item .title {
    display: none;
  }

  .nav_container .nav_list .nav_item {
    // padding-left: 14px;
    border-radius: 12px;
  }

  // logo显示文字or图片

  .nav_container .header_logo {
    padding-left: 8px;
  }

  .nav_container .header_logo .logo {
    padding: 0;
    display: block;
  }

  .nav_container .header_logo .logo_title,
  .nav_container .header_logo .logo_foreign {
    display: none;
  }
}

@media (min-width: 1336px) and (max-width: 1544px) {
  .header {
    flex: 0 0 280px;

    .qrCorde_box {

      .code_top {
        .code_top_lt {
          img {
            width: 80px;
            height: 80px;
          }
        }

        .code_top_rt {
          margin-left: 10px;

          h1 {
            font-size: 14px;
          }

          h6 {
            font-size: 10px;
          }

          .code_top_logo {
            height: 24px;
          }

          .code_top_scan {
            width: 14px;
            height: 14px;
          }
        }
      }

      .code_btn {
        height: 36px;
        margin-top: 16px;
        line-height: 36px;
      }
    }
  }

}

@media (min-width: 1280px) and (max-width: 1336px) {
  .header {
    flex: 0 0 240px;

    .qrCorde_box {
      display: flex;
      flex-direction: column;
      padding: 20px 16px;
      box-sizing: border-box;
      background-color: #F5F5F5;

      .code_top {
        display: flex;

        .code_top_lt {
          img {
            width: 60px;
            height: 60px;
          }
        }

        .code_top_rt {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin-left: 15px;

          h1 {
            display: none;
            font-size: 16px;
          }

          h6 {
            display: none;
            font-size: 12px;
            text-align: left;
          }

          .code_top_logo {
            height: 20px;
          }

          .code_top_scan {
            width: 12px;
            height: 12px;
          }
        }
      }

      .code_btn {
        height: 32px;
        margin-top: 16px;
        line-height: 32px;
      }
    }
  }

}

@media (min-width: 1144px) and (max-width: 1280px) {
  .header {
    flex: 0 0 56px;

    .qrCorde_box {
      display: none;
    }
  }
}

@media (min-width: 752px) and (max-width: 1144px) {
  .header {
    flex: 0 0 56px;

    .qrCorde_box {
      display: none;
    }
  }
}

@media (min-width: 0px) and (max-width: 752px) {
  .header {
    flex: 0 0 56px;

    .qrCorde_box {
      display: none;
    }
  }
}
</style>
